import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { z } from "zod";
import type { FeedbackSchema } from "../components/Feedback/schema";

export enum PatientSource {
  CURAI = "curai",
  AMAZON = "amazon",
  UNIVERSAL = "universal",
}

interface ProviderFeedbackRequest {
  title: string;
  description: string;
  patientId: string;
  patientSource: PatientSource;
  userId: string | null;
  // Chai/Nori (Clerk) user id, e.g. "user_..."; Braintrust metadata.user_id join key. Universal
  // patients only (null otherwise). Sent as chai_user_id to the gateway via case conversion.
  chaiUserId: string | null;
  roomToken: string;
  providerId: number;
  encounterId: string;
  feedbackType: z.infer<typeof FeedbackSchema>["feedbackType"];
  careBlocking: boolean;
  replayId?: string;
  encounterServiceType?: string | null;
}

export const useReportProviderFeedback = ({
  patientId = "",
  onSuccess,
  onError,
}: {
  patientId?: string;
  onSuccess?: (response: { data: unknown }) => void;
  onError?: (error: Error) => void;
} = {}) => {
  return useApiMutation({
    mutationOptions: {
      mutationFn: (data: ProviderFeedbackRequest) =>
        axiosInstance.post("/tickets/feedback", data),
      mutationKey:
        QueryKeys.Patient.MedicalRecords.ProviderFeedback.CREATE(patientId),
      onSuccess,
      onError,
    },
  });
};
